import styled from 'styled-components';
import React from 'react';
import MuiWrapper from 'components/common/input/MuiWrapper';
import { FormControl, IconButton, MenuItem, Select, TextField } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { validInputString } from 'lib/library';
import { Clear } from '@material-ui/icons';
import { icon_magnifier } from 'components/base/images';
import { color } from 'styles/utils';
import CustomDatePicker from 'components/common/input/CustomDatePicker';

interface CloudProjectSearchProps {
  keyword: {
    value: string;
    onChange: (e: any) => void;
    setValue: (value: string) => void;
  };
  periodType: {
    value: string;
    onChange: (e: any) => void;
    setValue: (value: string) => void;
  };
  sortType: {
    value: string;
    onChange: (e: any) => void;
    setValue: (value: string) => void;
  };
  period: { value: Date; onChange: (e: any, cb: any) => void; setValue: (value: Date) => void };

  onSearchProject: () => void;
  onClaerKeyword: () => void;
}

const CloudProjectSearch = ({
  keyword,
  periodType,
  sortType,
  period,
  onSearchProject,
  onClaerKeyword,
}: CloudProjectSearchProps) => {
  const { t } = useTranslation();
  const periodList = [
    { value: 'all', name: `${t('GLOBAL_PERIOD_ALL')}` },
    { value: '15days', name: `${t('GLOBAL_PERIOD_CURRENT_SHORT')}` },
    { value: '30days', name: `${t('GLOBAL_PERIOD_CURRENT_MIDDLE')}` },
    { value: '90days', name: `${t('GLOBAL_PERIOD_CURRENT_LONG')}` },
    { value: 'user', name: `${t('GLOBAL_USER_CONFIGURED')}` },
  ];

  const sortList = [
    { value: 'oldest', name: `${t('GLOBAL_SORT_OLDEST')}` },
    { value: 'newest', name: `${t('GLOBAL_SORT_NEWEST')}` },
    { value: 'largest', name: `${t('GLOBAL_SORT_LARGEST')}` },
    { value: 'asc', name: `${t('GLOBAL_SORT_ASC')}` },
    { value: 'desc', name: `${t('GLOBAL_SORT_DESC')}` },
  ];

  return (
    <StyledCloudProjectSearch data-component-name="CloudProjectSearch">
      <div className="cloudProjectSearch__section searchBar">
        <MuiWrapper
          className="searchBar_wrapper"
          config={{
            borderColor: 'transparent',
            activeBorderColor: 'transparent',
            hoverBorderColor: 'transparent',
          }}
        >
          <>
            <TextField
              rows={1}
              className="radius-md projectList__search_bar"
              variant="outlined"
              fullWidth
              inputProps={{
                fontSize: 13,
                fontWeight: 400,
              }}
              placeholder={t('SEACH_FOR_PROJECT')}
              value={keyword.value || ''}
              onChange={e => {
                const checkText = validInputString(e.target.value);
                keyword.onChange({ value: checkText });
              }}
              onKeyPress={e => e.key === 'Enter' && onSearchProject()}
              InputProps={{
                endAdornment: (
                  <IconButton onClick={onClaerKeyword} edge="end">
                    <Clear />
                  </IconButton>
                ),
              }}
            />
            <button
              className="btn-reset projectList__search_btn"
              onClick={() => {
                onSearchProject();
              }}
            >
              <img src={icon_magnifier} alt="search" />
            </button>
          </>
        </MuiWrapper>
      </div>
      <div className="cloudProjectSearch__section filter">
        <MuiWrapper isGlobalStyle className="filter_selectbox">
          <FormControl fullWidth variant="outlined">
            <Select
              MenuProps={{
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                getContentAnchorEl: null,
              }}
              data-testid="sales_currency_drop"
              name="periodType"
              value={sortType.value || ''}
              onChange={sortType.onChange}
            >
              {sortList?.map((item: any, index: number) => {
                return (
                  <MenuItem key={index} value={item.value}>
                    {item.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </MuiWrapper>
        <MuiWrapper isGlobalStyle className="filter_selectbox">
          <FormControl fullWidth variant="outlined">
            <Select
              MenuProps={{
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                getContentAnchorEl: null,
              }}
              data-testid="sales_currency_drop"
              name="periodType"
              value={periodType.value || ''}
              onChange={periodType.onChange}
            >
              {periodList?.map((item: any, index: number) => {
                return (
                  <MenuItem key={index} value={item.value}>
                    {item.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </MuiWrapper>
        <div className="filter_datePicker">
          {periodType.value === 'user' && (
            <CustomDatePicker
              type="rangeDate"
              width={235}
              borderColor="#B5B7C1"
              height={40}
              value={period.value}
              onChange={period.onChange}
              autoFocus={true}
            />
          )}
        </div>
      </div>
    </StyledCloudProjectSearch>
  );
};

const StyledCloudProjectSearch = styled.div<{}>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .cloudProjectSearch__section {
    height: 40px;
    display: flex;
    &.searchBar {
      width: 350px;
    }
    &.filter {
      column-gap: 8px;
    }
  }

  .searchBar_wrapper {
    width: 100%;
    .MuiInputBase-root {
      background-color: #ffffff;
      border: 1px solid #e1e1e1;
    }
    .projectList__search_btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      width: 40px;
      height: 40px;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      background-color: ${color.navy_blue};
    }
  }

  .filter_selectbox {
    width: 160px;
    height: 40px;
  }
  .filter_datePicker {
    width: 235px;
    height: 40px;
  }
`;

export default CloudProjectSearch;
